import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/lib/util/colors";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: colors.lightBlue.darken3,
      },
      dark: {
        primary: colors.lightBlue.darken3,
      },
    },
  },
});
